import React, { useState, lazy } from 'react';
import { MapPin, Phone, Mail, Instagram, Clock, Send } from 'lucide-react';
export function Contact() {
  return <div className="w-full" data-id="element-334">
      <SplitInfo data-id="element-335" />
      <ContactForm data-id="element-336" />
    </div>;
}
/* ---------- 1. SPLIT INFO + MAP ---------- */
function SplitInfo() {
  return <section className="bg-white" data-id="element-337">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[680px]" data-id="element-338">
        {/* Left — info */}
        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-20 bg-white relative overflow-hidden" data-id="element-339">
          {/* Red speed streak accent */}
          <div className="absolute -top-1 left-0 w-28 h-1.5 bg-reach-red" data-id="element-340" />

          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4" data-id="element-341">
            Visit · Call · Train
          </p>
          <h1 className="font-bebas text-reach-black text-6xl md:text-7xl lg:text-[88px] leading-[0.9] tracking-wide mb-8" data-id="element-342">
            Where to
            <br data-id="element-343" />
            Find Us
          </h1>

          <div className="w-12 h-1 bg-reach-red mb-8" data-id="element-344" />

          {/* New Portrait Card */}
          <div className="mb-10 bg-reach-black p-6 rounded-[4px] max-w-[248px]" data-id="element-345">
            <img src="https://cdn.magicpatterns.com/uploads/nS7CAkLSbDsg56k6ey7c7u/FernandoB_Dec2022-42-2.jpg" alt="Coach Fernando Beltran portrait" className="w-[200px] h-[200px] object-cover object-top rounded-[4px] mb-5" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} data-id="element-346" />
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.2em] font-semibold mb-2" data-id="element-347">
              WHO READS THIS
            </p>
            <p className="font-inter text-white text-[18px] leading-snug" data-id="element-348">
              Coach Fernando reads every message and personally responds.
            </p>
          </div>

          <ul className="space-y-6" data-id="element-349">
            <li className="flex items-start gap-4" data-id="element-350">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-351">
                <MapPin size={18} className="text-reach-red" data-id="element-352" />
              </div>
              <a href="https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070" target="_blank" rel="noopener noreferrer" className="group" data-id="element-353">
                <p className="font-inter text-reach-black text-xl md:text-2xl font-semibold leading-snug group-hover:text-reach-red transition-colors" data-id="element-354">
                  6051 Alma Rd · McKinney, TX 75070
                </p>
                <p className="font-inter text-sm text-reach-black/60 mt-1 uppercase tracking-wider" data-id="element-355">
                  Inside INPOWERiQ Performance Center
                </p>
              </a>
            </li>

            <li className="flex items-center gap-4" data-id="element-356">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-357">
                <Phone size={18} className="text-reach-red" data-id="element-358" />
              </div>
              <a href="tel:7089804666" className="font-inter text-reach-black text-lg md:text-xl hover:text-reach-red transition-colors" data-id="element-359">
                (708) 980-4666
              </a>
            </li>

            <li className="flex items-center gap-4" data-id="element-360">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-361">
                <Mail size={18} className="text-reach-red" data-id="element-362" />
              </div>
              <a href="mailto:Fernando@reachperformancehq.com" className="font-inter text-reach-black text-base md:text-lg hover:text-reach-red transition-colors break-all" data-id="element-363">
                Fernando@reachperformancehq.com
              </a>
            </li>

            <li className="flex items-start gap-4" data-id="element-364">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-365">
                <Clock size={18} className="text-reach-red" data-id="element-366" />
              </div>
              <div data-id="element-367">
                <p className="font-inter text-reach-black text-lg font-semibold" data-id="element-368">
                  Mon – Fri
                </p>
                <p className="font-inter text-sm text-reach-black/60 uppercase tracking-wider mt-0.5" data-id="element-369">
                  See class schedule
                </p>
              </div>
            </li>

            <li className="flex items-center gap-4" data-id="element-370">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-371">
                <Instagram size={18} className="text-reach-red" data-id="element-372" />
              </div>
              <a href="https://instagram.com/reachperformancehq" target="_blank" rel="noopener noreferrer" className="font-inter text-reach-black text-lg hover:text-reach-red transition-colors" data-id="element-373">
                @reachperformancehq
              </a>
            </li>
          </ul>
        </div>

        {/* Right — map */}
        <div className="relative min-h-[400px] lg:min-h-0 bg-reach-black" data-id="element-374">
          <iframe title="Reach Performance location at 6051 Alma Rd, McKinney, TX" src="https://www.google.com/maps?q=6051%20Alma%20Rd%2C%20McKinney%2C%20TX%2075070&t=&z=15&ie=UTF8&iwloc=&output=embed" className="absolute inset-0 w-full h-full grayscale contrast-110" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-375" />
          {/* Subtle red accent bar */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-reach-red z-10 pointer-events-none" data-id="element-376" />
        </div>
      </div>
    </section>;
}
/* ---------- 2. CONTACT FORM ---------- */
type Status = 'idle' | 'submitting' | 'success' | 'error';
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xgoqybwb';
function ContactForm() {
  const [status, setStatus] = useState<Status>('idle');
  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    setStatus('submitting');
    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        form.reset();
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }
  const resetForm = () => setStatus('idle');
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-377">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-378">
        <div className="text-center mb-10" data-id="element-379">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-380">
            Get In Touch
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-381">
            Have a Question?
          </h2>
          <p className="font-inter text-reach-black/70 text-base md:text-lg mt-4 max-w-xl mx-auto" data-id="element-382">
            Send us a note. Coach Fernando reads every message.
          </p>
        </div>

        <div className="bg-white rounded-[4px] p-6 md:p-10 border-t-4 border-reach-red" data-id="element-383">
          {status === 'success' ? <div className="text-center py-10" data-id="element-384">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-385">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-386">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-387" />
                </svg>
              </div>
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide mb-3" data-id="element-388">
                Thanks, your message is in
              </h3>
              <p className="font-inter text-reach-black/75 max-w-md mx-auto mb-6" data-id="element-389">
                Coach Fernando typically responds within 24 hours.
              </p>
              <button type="button" onClick={resetForm} className="inline-flex items-center justify-center font-inter font-semibold text-sm uppercase tracking-wider px-5 py-2.5 border-2 border-reach-black text-reach-black rounded hover:bg-reach-black hover:text-white transition-colors" data-id="element-390">
                Send another
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-391">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-392">
                <Field id="name" label="Name" required type="text" placeholder="Your name" data-id="element-393" />
                <Field id="email" label="Email" required type="email" placeholder="you@example.com" data-id="element-394" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-395">
                <Field id="phone" label="Phone" type="tel" placeholder="(555) 123-4567" data-id="element-396" />
                <div data-id="element-397">
                  <label htmlFor="age" className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-398">
                    Athlete's Age
                  </label>
                  <select id="age" name="age" className="w-full px-4 py-3 min-h-[48px] bg-white border-2 border-black/15 rounded font-inter text-base text-reach-black focus:outline-none focus:border-reach-red transition-colors" data-id="element-399">
                    <option value="" data-id="element-400">Select age</option>
                    <option value="8-10" data-id="element-401">8–10 (Youth)</option>
                    <option value="11-13" data-id="element-402">11–13 (Middle School)</option>
                    <option value="14-18" data-id="element-403">14–18 (High School)</option>
                    <option value="other" data-id="element-404">Other / Multiple</option>
                    <option value="pro-collegiate" data-id="element-405">Pro / Collegiate</option>
                  </select>
                </div>
              </div>

              <div data-id="element-406">
                <label htmlFor="message" className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-407">
                  Message
                </label>
                <textarea id="message" name="message" required rows={5} placeholder="What can we help with?" className="w-full px-4 py-3 bg-white border-2 border-black/15 rounded font-inter text-base text-reach-black focus:outline-none focus:border-reach-red transition-colors resize-none" data-id="element-408" />
              </div>

              <button type="submit" disabled={status === 'submitting'} className="btn-primary w-full sm:w-auto disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-409">
                <Send size={16} className="mr-2" data-id="element-410" />
                {status === 'submitting' ? 'Sending' : 'Send'}
              </button>

              {status === 'error' && <p className="font-inter text-sm text-red-600" data-id="element-411">
                  Something went wrong. Please email
                  Fernando@reachperformancehq.com or call 708-980-4666.
                </p>}
            </form>}
        </div>

        <p className="text-center font-inter text-xs uppercase tracking-[0.25em] text-reach-black/50 mt-8" data-id="element-412">
          We typically respond within 24 hours
        </p>
      </div>
    </section>;
}
function Field({
  id,
  label,
  type,
  placeholder,
  required
}: {
  id: string;
  label: string;
  type: string;
  placeholder?: string;
  required?: boolean;
}) {
  return <div data-id="element-413">
      <label htmlFor={id} className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-414">
        {label}
        {required && <span className="text-reach-red ml-1" data-id="element-415">*</span>}
      </label>
      <input id={id} name={id} type={type} placeholder={placeholder} required={required} className="w-full px-4 py-3 min-h-[48px] bg-white border-2 border-black/15 rounded font-inter text-base text-reach-black placeholder:text-reach-black/40 focus:outline-none focus:border-reach-red transition-colors" data-id="element-416" />
    </div>;
}